import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { logoutUser, loginDataReset } from "../../../store/actions"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const history = useNavigate()
  const dispatch = useDispatch()
  const loginUser = useSelector(state => state.loginUser)

  const logoutHandler = () => {
    dispatch(logoutUser(history))
    dispatch(loginDataReset())
    history("/login")
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          {/* {loginUser && loginUser.userData && loginUser.userData.emp_ProfilePic &&
            <img
              className="rounded-circle header-profile-user"
              src={loginUser.userData.emp_ProfilePic}
              alt="Avatar"
            />
          }
          {loginUser && loginUser.userData && loginUser.userData.userName &&
            <>
              <span className="d-none d-xl-inline-block ms-2 me-1">{loginUser.userData.userName}</span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
            </>
          } */}
          <>
            <span className=" d-xl-inline-block ms-2 me-1">
              {/* {loginUser.userData.userName} */} Admin
            </span>
            <i className="mdi mdi-chevron-down  d-xl-inline-block" />
          </>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="/crypto-wallet">
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </DropdownItem>
          <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
          <div className="dropdown-divider" />
          <button onClick={logoutHandler} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </button>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
